import { FC } from 'react';
import { Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
// @ts-ignore
import { getConfig } from '@edx/frontend-platform';

import { PurchaseCard, PlusButton } from 'pages/Dashboard/components/PurchaseNewLearningCard/style';

/**
 * "Purchase New Learning" tile shown at the end of the Suggested Learning
 * list. Links to the same catalog URL used by the header dropdown menu.
 */
const PurchaseNewLearningCard: FC = () => {
  const purchaseNewLearningUrl = getConfig().PURCHASE_NEW_LEARNING_URL || '';

  return (
    <PurchaseCard
      className='card'
      href={purchaseNewLearningUrl}
      aria-label='Purchase New Learning – Browse the full catalog'
    >
      <PlusButton className='purchase-icon' aria-hidden='true'>
        <AddIcon />
      </PlusButton>
      <Typography variant='h3' className='fw-700 purchase-title'>
        Purchase New Learning
      </Typography>
      <Typography variant='body2' className='purchase-subtitle'>
        Browse the full catalog
      </Typography>
    </PurchaseCard>
  );
};

export default PurchaseNewLearningCard;
